module.exports = __webpack_public_path__ + "img/lbl03.0a0461e2.png";